import config from "../config/config";
import { userService } from "../services";

export const companyWiseEmp = {
  updateUserConvenseRatePermission,
  saveGeofenceDistanceByCompany,
  getGeofenceDistanceByCompany,
  saveNotificationConfigurationForShiftCompletion,
  saveNotificationConfiguration,
  saveDepartmentConfiguration,
  getDepartmentConfigurationByCompanyId,
  getUndertakingByCompanyId,
  saveUndertakingForm,
  setActiveInActiveUsers,
  getAllActiveInActiveUsers,
  getAllOrderManagementPage,
  saveOrderDynamicHeader,
  getAllOrderManagementHeader,
  getUserListByCompanyIdForDefaultMeeting,
  saveDefaultMeetingPermissionUserWise,
  saveCameraConfig,
  getCameraTypes,
  getCameraConfigDataForPage,
  getCameraEnabledPages,
  saveBankDetailsByCompany,
  fetchAllBankDetailsByCompany,
  fetchRemovePermissionForUser,
  fetchSavePermissionForUser,
  fetchAllOrderPermissions,
  fetchOrderPermissionsByUser,
  fetchCompnyWiseUpdate,
  fetchCompnatbyData,
  fetchUserConfigurationData,
  fetchGeofance,
  fetchattendenceconfigurationList,
  fetchgeofenceconfiguration,
  fetchcompanyclientstatus,
  fetchcompanyclientstatusmaster,
  fetchDeletecompanyclientstatusmaster,
  fetchupdatecompanyclientstatus,
  fetchupdateclientstatus,
  getWhatsappConfiguration,
  saveWhatsappMaxMessageLimit,
  getCompanywiseWhatsappMessageCount,
  fetchRestoreOdForUser,
  getMultiLevelApproverByCompanyId,
  saveMultiLevelApproverForComapny,
  getHrmsUserListByCompanyId,
  saveUserLoginConfigurationByComapnyId,
  deleteMultiLevelApproverForComapny,
  getAllUndertakingFormsByCompanyId,
  thirdPartyApiSync,
  fetchRestoreDeviceForUser,
  getAllCompanyWiseAds,
  saveCompanyWiseAds,
  getAllModules,
  getAllCompanyWiseSite,
  getAllOdRestorationEmployee,
  updateOdRestorationEmployee,
  restoreOdForEmployee,
  getAllUserAccessPermissions,
  saveUsersAccessPermissions,
  getUserSites,
  saveUserSites,
};

async function getUserSites(payload) {
  const apiEndpoint = config.baseUrl + config.apiName.userSites;
  const response = await userService.post(apiEndpoint, payload);
  if (response.status === 200) {
    return response.data;
  } else {
    return response.response?.data || response.message;
  }
}

async function saveUserSites(payload) {
  const apiEndpoint = config.baseUrl + config.apiName.saveUserSites;
  const response = await userService.post(apiEndpoint, payload);
  if (response.status === 200) {
    return response.data;
  } else {
    return response.response?.data || response.message;
  }
}

async function updateUserConvenseRatePermission(payload) {
  const apiEndpoint =
    config.baseUrl + config.apiName.updateUserConvenseRatePermission;
  const response = await userService.post(apiEndpoint, payload);
  if (response.status === 200) {
    return response.data;
  } else {
    return response.response?.data || response.message;
  }
}

async function saveGeofenceDistanceByCompany(payload) {
  const apiEndpoint = `${config.baseUrl}${config.apiName.saveGeofenceDistanceByCompany}`;
  const response = await userService.post(apiEndpoint, payload);
  if (response.status === 200) {
    return response.data;
  } else {
    return response.response?.data || response.message;
  }
}

async function getGeofenceDistanceByCompany(payload) {
  const apiEndpoint = `${config.baseUrl}${
    config.apiName.getGeofenceDistanceByCompany
  }?companyId=${payload?.companyId}${
    payload?.siteId ? `&siteId=${payload.siteId}` : ""
  }`;
  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  }
  return null;
}

async function saveNotificationConfigurationForShiftCompletion(payload) {
  const apiEndpoint = `${config.baseUrl}${config.apiName.saveNotificationConfigurationForShiftCompletion}`;
  const response = await userService.post(apiEndpoint, payload);
  if (response.status === 200) {
    return response.data;
  } else {
    return response.response?.data || response.message;
  }
}

async function saveNotificationConfiguration(payload) {
  const apiEndpoint = `${config.baseUrl}${config.apiName.saveNotificationConfiguration}`;
  const response = await userService.post(apiEndpoint, payload);
  if (response.status === 200) {
    return response.data;
  } else {
    return response.response?.data || response.message;
  }
}

async function saveDepartmentConfiguration(payload) {
  const apiEndpoint = `${config.baseUrl}${config.apiName.saveDepartmentConfiguration}`;
  const response = await userService.post(apiEndpoint, payload);
  if (response.status === 200) {
    return response.data;
  } else {
    return response.response?.data || response.message;
  }
}

async function getDepartmentConfigurationByCompanyId(payload) {
  const apiEndpoint = payload.siteId
    ? `${config.baseUrl}${config.apiName.getDepartmentConfigurationByCompanyId}?hrmsCompanyId=${payload.hrmsCompanyId}&hrmsToken=${payload.hrmsToken}&siteId=${payload.siteId}`
    : `${config.baseUrl}${config.apiName.getDepartmentConfigurationByCompanyId}?hrmsCompanyId=${payload.hrmsCompanyId}&hrmsToken=${payload.hrmsToken}`;
  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function getUndertakingByCompanyId(companyId) {
  const apiEndpoint = `${config.baseUrl}${config.apiName.getUndertakingByCompanyId}?hrmsCompanyId=${companyId}`;
  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return response.response?.data || response.message;
  }
}

async function getAllUndertakingFormsByCompanyId(companyId, isActive) {
  let apiEndpoint = `${config.baseUrl}${config.apiName.getAllUndertakingFormsByCompanyId}?hrmsCompanyId=${companyId}`;

  if (isActive !== null && isActive !== undefined) {
    apiEndpoint += `&isActive=${isActive}`;
  }
  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return response.response?.data || response.message;
  }
}

async function saveUndertakingForm(payload) {
  let apiEndpoint = `${config.baseUrl}${config.apiName.saveUndertakingForm}`;
  const response = await userService.post(apiEndpoint, payload);
  if (response.status === 200) {
    return response.data;
  } else {
    return response.response?.data || response.message;
  }
}

async function setActiveInActiveUsers(payload) {
  let apiEndpoint = `${config.baseUrl}${config.apiName.setActiveInActiveUsers}`;
  const response = await userService.post(apiEndpoint, payload);
  if (response.status === 200) {
    return response.data;
  }
  return null;
}

async function getAllActiveInActiveUsers(payload) {
  let apiEndpoint = `${config.baseUrl}${
    config.apiName.getAllActiveInActiveUsers
  }?companyId=${payload.companyId}&isActive=${payload.isActive}${
    payload.siteId ? `&siteId=${payload.siteId}` : ""
  }`;
  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  }
  return null;
}

async function getAllOrderManagementPage() {
  let apiEndpoint = `${config.baseUrl}${config.apiName.getAllOrderManagementPage}`;
  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  }
  return null;
}

async function saveOrderDynamicHeader(payload) {
  let apiEndpoint = `${config.baseUrl}${config.apiName.saveOrderDynamicHeader}`;
  const response = await userService.post(apiEndpoint, payload);
  if (response.status === 200) {
    return response.data;
  }
  return null;
}

async function getAllOrderManagementHeader(companyId, pageId) {
  let apiEndpoint = `${config.baseUrl}${config.apiName.getAllOrderManagementHeader}/${companyId}/${pageId}`;
  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function getUserListByCompanyIdForDefaultMeeting(payload) {
  let apiEndPoint = `${config.baseUrl}${
    config.apiName.getUserListByCompanyIdForDefaultMeeting
  }?companyId=${payload.companyId}${
    payload.siteId ? `&siteId=${payload.siteId}` : ""
  }`;
  let response = await userService.get(apiEndPoint);
  if (response?.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function saveDefaultMeetingPermissionUserWise(payload) {
  let apiEndPoint = `${config.baseUrl}${config.apiName.saveDefaultMeetingPermissionUserWise}`;
  const response = await userService.post(apiEndPoint, payload);
  if (response.status === 200) {
    return response.data;
  }
  return null;
}

async function saveCameraConfig(payload) {
  let apiEndPoint = `${config.baseUrl}${config.apiName.saveCameraConfig}`;
  const response = await userService.post(apiEndPoint, payload);
  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function getCameraTypes() {
  let apiEndPoint = `${config.baseUrl}${config.apiName.getCameraTypes}`;
  const response = await userService.get(apiEndPoint);
  if (response.status) {
    return response.data;
  } else {
    return null;
  }
}

async function getCameraConfigDataForPage(payload) {
  let apiEndPoint = `${config.baseUrl}${config.apiName.getCameraConfigDataForPage}?companyId=${payload.companyId}&cameraPageId=${payload.pageId}`;
  const response = await userService.get(apiEndPoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function getCameraEnabledPages(companyId) {
  let apiEndPoint = `${config.baseUrl}${config.apiName.getCameraEnabledPages}?companyId=${companyId}`;
  const response = await userService.get(apiEndPoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function saveBankDetailsByCompany(payload) {
  let apiEndpoint = `${config.baseUrl}${config.apiName.saveBankDetailsByCompany}`;
  const response = await userService.post(apiEndpoint, payload);
  return response;
}

async function fetchAllBankDetailsByCompany(companyId) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.getAllBankDetailsByCompany}?companyId=${companyId}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.error(err.message);
    return null;
  }
}

async function fetchRemovePermissionForUser(payload) {
  try {
    let apiEndPoint = `${config.baseUrl}${config.apiName.removePermissionForUser}`;
    const response = await userService.post(apiEndPoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
}

async function fetchSavePermissionForUser(payload) {
  try {
    let apiEndPoint = `${config.baseUrl}${config.apiName.savePermissionForUser}`;
    const response = await userService.post(apiEndPoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
}

async function fetchAllOrderPermissions() {
  try {
    let apiEndPoint = `${config.baseUrl}${config.apiName.allOrderPermissionList}`;
    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
}

async function fetchOrderPermissionsByUser(payload) {
  try {
    let apiEndPoint = `${config.baseUrl}${config.apiName.orderPermissionListByUser}`;
    const response = await userService.post(apiEndPoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
}

async function fetchCompnyWiseUpdate(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.companyWiseUpdate}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchCompnatbyData(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.companyCongigurationData}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchUserConfigurationData(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.geofenceconfiguration}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchGeofance(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.companyCongigurationData}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchattendenceconfigurationList(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.attendenceconfigurationList}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchgeofenceconfiguration(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.attendenceconfigurationList}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchcompanyclientstatus(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.companyclientstatus}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchcompanyclientstatusmaster(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.clientstatusmaster}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchDeletecompanyclientstatusmaster(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.deletecompanyclientstatus}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchupdatecompanyclientstatus(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.updatecompanyclientstatus}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchupdateclientstatus(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.updateclientstatus}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function getWhatsappConfiguration(payload) {
  try {
    const apiEndpoint = `${
      config?.baseUrl + config?.apiName?.getWhatsappConfiguration
    }?companyId=${payload.companyId}`;
    const response = await userService.get(apiEndpoint);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function saveWhatsappMaxMessageLimit(payload) {
  try {
    let apiEndpoint = `${config?.baseUrl}${config?.apiName?.saveWhatsappMaxMessageLimit}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function getCompanywiseWhatsappMessageCount(payload) {
  try {
    let apiEndpoint = `${config?.baseUrl}${config?.apiName?.getCompanywiseWhatsappMessageCount}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function fetchRestoreOdForUser(payload) {
  try {
    let apiEndpoint = `${config?.baseUrl}${config?.apiName?.restoreOdForUser}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    console.log("error", error);
    return error;
  }
}
async function fetchRestoreDeviceForUser(payload) {
  try {
    let apiEndpoint = `${config?.baseUrl}${config?.apiName?.restoreDeviceForUser}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    console.log("error", error);
    return error;
  }
}
async function getMultiLevelApproverByCompanyId(payload) {
  let apiEndpoint = `${config.baseUrl}${config.apiName.multiLevelApproverByCompanyId}/${payload}`;
  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function saveMultiLevelApproverForComapny(payload) {
  try {
    let apiEndpoint = `${config?.baseUrl}${config?.apiName?.saveMultiLevelApproverByCompanyId}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function getHrmsUserListByCompanyId(payload) {
  let apiEndpoint = `${config.baseUrl}${
    config.apiName.hrmsUserList
  }?companyId=${payload.companyId}&authToken=${payload?.hrmsToken}${
    payload.siteId ? `&siteId=${payload.siteId}` : ""
  }`;

  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function saveUserLoginConfigurationByComapnyId(payload) {
  try {
    let apiEndpoint = `${config?.baseUrl}${config?.apiName?.updateUserLoginPermission}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function deleteMultiLevelApproverForComapny(payload) {
  try {
    let apiEndpoint = `${config?.baseUrl}${config?.apiName?.deleteMultiLevelApproverByCompanyId}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function thirdPartyApiSync(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.syncThirdPartyApi}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function saveCompanyWiseAds(payload) {
  try {
    let apiEndpoint = `${config?.baseUrl}${config?.apiName?.saveCompanyWiseAds}`;
    const response = await userService.post(apiEndpoint, payload);
    console.log("ads res : ", response);
    if (response) {
      if (response?.status === 200) {
        return response?.data;
      } else if (response?.response?.status === 400) {
        return response?.response?.data;
      }
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    console.log("ads res error : ", error);
    return null;
  }
}

async function getAllCompanyWiseAds(payload) {
  let apiEndpoint = `${config.baseUrl}${config.apiName.getAllCompanyWiseAds}?companyId=${payload.companyId}`;

  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function getAllModules() {
  let apiEndpoint = `${config.baseUrl}${config.apiName.getAllModules}`;

  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function getAllCompanyWiseSite(payload) {
  const apiEndpoint = buildUrl(
    `${config.baseUrl}${config.apiName.getAllCompanyWiseSite}`,
    payload,
  );
  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function getAllOdRestorationEmployee(payload) {
  const apiEndpoint = `${config.baseUrl}${config.apiName.getOdRestorationEmployeeList}?companyId=${payload?.companyId}`;
  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  }
  return null;
}

async function updateOdRestorationEmployee(payload) {
  const apiEndpoint = `${config.baseUrl}${config.apiName.odRestorationPermissionUpdate}`;
  const response = await userService.post(apiEndpoint, payload);
  if (response.status === 200) {
    return response.data;
  } else {
    return response.response?.data || response.message;
  }
}

async function restoreOdForEmployee(payload) {
  const apiEndpoint = `${config.baseUrl}${config.apiName.restoreOd}`;
  const response = await userService.post(apiEndpoint, payload);
  if (response.status === 200) {
    return response.data;
  } else {
    return response.response?.data || response.message;
  }
}

async function getAllUserAccessPermissions(payload) {
  const apiEndpoint = buildUrl(
    `${config.baseUrl}${config.apiName.getAllUserAccessPermissions}`,
    payload,
  );
  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function saveUsersAccessPermissions(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.saveUsersAccessPermissions}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

function buildUrl(baseUrl, params) {
  const url = new URL(baseUrl);

  // Filter and append valid params
  Object.entries(params).forEach(([key, value]) => {
    if (value != null) {
      url.searchParams.append(key, value);
    }
  });

  return url.toString();
}
